<template>
  <q-btn
    round
    :dense="dense"
    class="--shadow__bottom"
    @click.stop.prevent="promptShareVehicleDialog"
    @mousedown.stop="() => {}"
    @mouseup.stop="() => {}"
    no-caps
  >
    <q-icon name="sym_r_ios_share" size="22px" style="margin-top: -2px" />
    <q-tooltip
      anchor="center left"
      self="center right"
      max-width="300px"
      :offset="[6, 6]"
      persistent
    >
      Share Listing
    </q-tooltip>

    <q-dialog
      v-model="showShareVehicleDialog"
      v-cloak
      class="--fullscreen-height__padded"
    >
      <q-card style="width: 100%; max-width: 400px;">
        <DialogHeader
          header="Share Listing"
          header-icon=""
          @close="showShareVehicleDialog = false"
        />

        <q-card-section class="column items-center" style="margin-top: -16px">
          <!-- Vehicle Image -->
          <q-img
            :src="vehicle.images?.[0]"
            class="--rounded --bordered --shadow__bottom"
          />

          <!-- Vehicle Title -->
          <h5 class="text-center q-mt-lg q-mb-sm">
            {{ vehicle.title_raw }}
          </h5>

          <!--<div class="text-center q-mt-sm q-mb-sm">
            <h5 class="q-mb-none"><span class="text-text-light text-weight-medium --text-sm">Listed at</span> {{ vehicle.price_formatted }}<span class="text-text-light text-weight-medium --text-sm">.</span></h5>
          </div>-->

          <!-- Divider -->
          <q-separator class="full-width q-my-md" />

          <!-- Share Text -->
          <div class="text-text-light q-mb-md">
            Share this listing via:
          </div>

          <!-- Share Buttons -->
          <div class="row q-gutter-md q-mb-lg">
            <q-btn
              round
              size="lg"
              class="--bordered --shadow__bottom"
              color="background-light"
              @click="shareViaFacebook"
            >
              <svg
                fill="#ffffff"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                id="facebook"
                data-name="Flat Color"
                xmlns="http://www.w3.org/2000/svg"
                class="icon flat-color"
              >
                <path
                  id="primary"
                  d="M14,6h3a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H14A5,5,0,0,0,9,7v3H7a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1H9v7a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V14h2.22a1,1,0,0,0,1-.76l.5-2a1,1,0,0,0-1-1.24H13V7A1,1,0,0,1,14,6Z"
                ></path>
              </svg>
              <q-tooltip
                anchor="center left"
                self="center right"
                max-width="300px"
                :offset="[6, 6]"
                persistent
              >
                Share via Facebook
              </q-tooltip>
            </q-btn>
            <q-btn
              round
              size="lg"
              class="--bordered --shadow__bottom"
              color="background-light"
              @click="shareViaWhatsApp"
            >
              <svg
                fill="#ffffff"
                height="24px"
                width="24px"
                version="1.1"
                id="Icons"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 32 32"
                xml:space="preserve"
              >
                <path
                  d="M17,0C8.7,0,2,6.7,2,15c0,3.4,1.1,6.6,3.2,9.2l-2.1,6.4c-0.1,0.4,0,0.8,0.3,1.1C3.5,31.9,3.8,32,4,32c0.1,0,0.3,0,0.4-0.1
	l6.9-3.1C13.1,29.6,15,30,17,30c8.3,0,15-6.7,15-15S25.3,0,17,0z M25.7,20.5c-0.4,1.2-1.9,2.2-3.2,2.4C22.2,23,21.9,23,21.5,23
	c-0.8,0-2-0.2-4.1-1.1c-2.4-1-4.8-3.1-6.7-5.8L10.7,16C10.1,15.1,9,13.4,9,11.6c0-2.2,1.1-3.3,1.5-3.8c0.5-0.5,1.2-0.8,2-0.8
	c0.2,0,0.3,0,0.5,0c0.7,0,1.2,0.2,1.7,1.2l0.4,0.8c0.3,0.8,0.7,1.7,0.8,1.8c0.3,0.6,0.3,1.1,0,1.6c-0.1,0.3-0.3,0.5-0.5,0.7
	c-0.1,0.2-0.2,0.3-0.3,0.3c-0.1,0.1-0.1,0.1-0.2,0.2c0.3,0.5,0.9,1.4,1.7,2.1c1.2,1.1,2.1,1.4,2.6,1.6l0,0c0.2-0.2,0.4-0.6,0.7-0.9
	l0.1-0.2c0.5-0.7,1.3-0.9,2.1-0.6c0.4,0.2,2.6,1.2,2.6,1.2l0.2,0.1c0.3,0.2,0.7,0.3,0.9,0.7C26.2,18.5,25.9,19.8,25.7,20.5z"
                />
              </svg>
              <q-tooltip
                anchor="center left"
                self="center right"
                max-width="300px"
                :offset="[6, 6]"
                persistent
              >
                Share via WhatsApp
              </q-tooltip>
            </q-btn>

            <q-btn
              round
              size="lg"
              class="--bordered --shadow__bottom"
              color="background-light"
              @click="shareViaSMS"
            >
              <q-icon name="sym_r_sms" size="28px" class="--icon-filled" />
              <q-tooltip
                anchor="center left"
                self="center right"
                max-width="300px"
                :offset="[6, 6]"
                persistent
              >
                Share via Text/SMS
              </q-tooltip>
            </q-btn>
          </div>

          <!-- Copy Link Section -->
          <div
            class="full-width bg-background-light rounded-borders q-pa-md row items-center no-wrap"
            style="max-width: 100%;"
          >
            <div
              class="col ellipsis text-grey-5 q-pr-md"
              style="font-size: 14px;"
            >
              {{ shareUrl }}
            </div>
            <q-btn
              flat
              dense
              no-caps
              color="secondary"
              @click="copyToClipboard"
            >
              <div class="flex items-center">
                <q-icon
                  v-if="!linkCopied"
                  name="sym_r_content_copy"
                  size="18px"
                  class="q-mr-xs"
                />
                <div>{{ linkCopied ? "Link Copied!" : "Copy link" }}</div>
              </div>
            </q-btn>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-btn>
</template>

<script>
import DialogHeader from "@/components/UI/DialogHeader.vue";

export default {
  name: "VehicleShareButton",
  components: { DialogHeader },
  props: {
    vehicle: {
      type: Object,
      required: true
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showShareVehicleDialog: false,
      linkCopied: false
    };
  },
  computed: {
    shareUrl() {
      return `https://carscience.com?pid=${this.vehicle.product_id}`;
    }
  },
  mounted() {},
  beforeUnmount() {},
  methods: {
    promptShareVehicleDialog() {
      this.showShareVehicleDialog = true;
    },
    shareViaFacebook() {
      const url = encodeURIComponent(this.shareUrl);
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${url}`,
        "_blank"
      );
    },
    shareViaWhatsApp() {
      const text = encodeURIComponent(
        `Check out this vehicle: ${this.shareUrl}`
      );
      window.open(`https://wa.me/?text=${text}`, "_blank");
    },
    shareViaSMS() {
      const text = encodeURIComponent(
        `Check out this vehicle: ${this.shareUrl}`
      );
      window.location.href = `sms:?&body=${text}`;
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.shareUrl).then(() => {
        this.linkCopied = true;
      });
    }
  }
};
</script>
